import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

interface CheckProps {
  value: boolean;
}

export const Check = ({ value }: CheckProps) => (value ? <CheckOutlined /> : <CloseOutlined />);
